import React, { createContext, useState } from "react";

import { tokenType } from "shared/common/services/Login";

type AuthContextProps = {
  userData?: userDataProps;
  setUserData: (userData: userDataProps) => void;
  tokens?: tokenType;
  setTokens: (tokens: tokenType) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  logoutAPI: () => void;
};

export type userDataProps = {
  tenant: string;
  user_familyname?: string;
  user_firstname?: string;
  usergroups: string[];
  usermail?: string;
  username: string;
  userpool_id: string;
  scope: string[];
  sub: string;
  client_id: string;
  isMigrated: boolean;
  isAdmin: boolean;
};

const AuthContext = createContext({} as AuthContextProps);

type AuthProviderProps = {
  children: React.ReactNode;
  onLogout?: () => void;
};

export function AuthProvider({ children, onLogout }: AuthProviderProps) {
  const [userData, setUserData] = useState<userDataProps>();
  const [tokens, setTokens] = useState<tokenType>();
  const [loading, setLoading] = useState(true);

  // Notify API integration, that a logout was initiated
  const logoutAPI = () => {
    if (onLogout) {
      onLogout();
    } else {
      console.warn("Logout triggered but no onLogout provided");
    }
  };

  return (
    <AuthContext.Provider
      value={{
        userData: userData,
        setUserData: setUserData,
        tokens: tokens,
        setTokens: setTokens,
        loading: loading,
        setLoading: setLoading,
        logoutAPI: logoutAPI,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
